import { render, staticRenderFns } from "./PurchasePrice.pug?vue&type=template&id=e2f95458&lang=pug&"
import script from "./PurchasePrice.vue?vue&type=script&lang=js&"
export * from "./PurchasePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports